import Button from 'components/common/Button';

type ReportType = 'block' | 'report';

interface ActionDetailProps {
  type: ReportType;
  userInfo: UserInfo;
  onClose: () => void;
  onConfirm: () => void;
}

const BlockReportConfirm = ({ type, userInfo, onClose, onConfirm }: ActionDetailProps) => {
  const isBlock = type === 'block';

  const config = {
    title: isBlock ? brsc.report_sent_n_block : brsc.confirm_report,
    description: isBlock ? brsc.ask_block.replace('$param', userInfo.nick) : null,
    btnText: isBlock ? brsc.block : brsc.report_2,
  };

  return (
    <div className="flex flex-col gap-6">
      <div className="flex w-full flex-col gap-4">
        <div className="typography-title-md w-full text-center text-base-txt-primary">{config.title}</div>
        {config.description && <div className="typography-body-sm w-full text-base-txt-secondary">{config.description}</div>}
      </div>

      <div className="flex gap-[2px] p-2">
        <Button
          onClick={onConfirm}
          className="flex-[5]"
          style={{
            text: config.btnText,
            type: 'solid',
            color: 'btn-bg-alert',
            fontColor: 'base-txt-primary',
            borderRadius: 'full',
          }}
        />
        <Button
          onClick={onClose}
          className="flex-[1] rounded-l-md rounded-r-xl"
          style={{
            type: 'solid',
            color: 'btn-bg-normal',
            icon: { name: 'profile/close.svg', size: 24 },
          }}
        />
      </div>
    </div>
  );
};

export default BlockReportConfirm;
